// Core viewer
import { Viewer, SpecialZoomLevel} from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { useResizeDetector } from 'react-resize-detector';

// Plugins

// Import styles
import '@react-pdf-viewer/core/lib/styles/index.css';


// Import styles
import '@react-pdf-viewer/default-layout/lib/styles/index.css';



export const PdfViewer = ({url, loaded}) => {
    const { width, height, ref } = useResizeDetector();
    
    
    return <div  ref={ref} style={{height: '100%'}}>
        <div style={{ width: width, height: height }}>
        <Viewer
        fileUrl={url}
        defaultScale={SpecialZoomLevel.PageFit}
        renderLoader={(percentage) => {
            if (percentage >= 100) {
                loaded && loaded()
            }
        }}
        plugins={[
            // Register plugins
            defaultLayoutPlugin(),
        ]} />
        </div>
    </div>;
  };